// @ts-nocheck
/* eslint-disable */
import { CONFIG } from "~/config";

(function() {
	const URL = "/sm/long";

	let urlSidCache = {};
	let sidUrlCache = {};

	Mapy.ProviderSID = {};

	Mapy.ProviderSID.getSID = url => {
		return new Promise((resolve, reject) => {
			if (!(url in urlSidCache)) {
				urlSidCache[url] = Mapy.Util.request(CONFIG.requestUrl + URL, { json: { url }, type: "json"}).promise;
			}

			urlSidCache[url].then(d => {
				if (d.status == 200 && d.data.id) {
					sidUrlCache[d.data.id] = Promise.resolve({ status: 200, data: { url } });
					resolve({ sid: d.data.id });
				}
				else {
					reject();
				}
			}, e => {
				reject(e);
			});
		});
	}

	Mapy.ProviderSID.getData = sid => {
		return new Promise((resolve, reject) => {
			if (!(sid in sidUrlCache)) {
				sidUrlCache[sid] = Mapy.Util.request(CONFIG.requestUrl + URL + "/" + sid, { method: "get", type: "json", headers: { "Content-Type": "application/json" }}).promise;
			}

			sidUrlCache[sid].then(d => {
				if (d.status == 200 && d.data.url) {
					urlSidCache[d.data.url] = Promise.resolve({ status: 200, data: { id: sid } });
					resolve({ url: d.data.url });
				}
				else {
					reject();
				}
			}, e => {
				reject(e);
			});
		});
	}
})();
